import { API_ROUTES } from "../../configuration/RoutesApi"
import { AdminLandingLead } from "../../Objects/LandingLead/AdminLandingLead"
import { ERequestType } from "../../Enum/ERequestType"
import { GetRequest, PutRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"

export const useAdminLandingLead = () => {
  const { setError } = useError()

  const { enableLoad, disableLoad } = useLoad()

  const handleGetAll = async (onSuccess: (data: AdminLandingLead[]) => void) => {
     enableLoad()

    try {
      const response = await GetRequest<AdminLandingLead[]>(API_ROUTES.LANDING_LEAD.ADMIN_GET_ALL, ERequestType.Admin)

      if (!response.success) throw new Error(response.message)

      onSuccess((response.data ?? []).map((e) => new AdminLandingLead(e)))
    } catch (ex) {
      const message = ex instanceof Error ? ex.message : "Erro ao carregar leads da landing."
      setError("Leads landing", message)
    } finally { disableLoad() }
  }

  const handleUpdateContactStatus = async (id: number, hasBeenContacted: boolean, onSuccess: () => void) => {
    try {
      const response = await PutRequest(API_ROUTES.LANDING_LEAD.ADMIN_UPDATE_CONTACT_STATUS(id), { hasBeenContacted }, ERequestType.Admin)

      if (!response.success) throw new Error(response.message)

      onSuccess()
    } catch (ex) {
      const message = ex instanceof Error ? ex.message : "Erro ao carregar leads da landing."
      setError("Leads landing", message)
    } finally { disableLoad() }
  }

  return { handleGetAll, handleUpdateContactStatus }
}
